import { render } from "./ListadoVentasDashboard.vue?vue&type=template&id=c141ee9e&scoped=true"
import script from "./ListadoVentasDashboard.vue?vue&type=script&lang=js"
export * from "./ListadoVentasDashboard.vue?vue&type=script&lang=js"

import "./ListadoVentasDashboard.vue?vue&type=style&index=0&id=c141ee9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c141ee9e"]])

export default __exports__